function isOnScreen(elem) {
  if (!elem.length) return;
  const $window = jQuery(window);
  const viewportTop = $window.scrollTop();
  const viewportHeight = $window.height();
  const viewportBottom = viewportTop + viewportHeight;
  const $elem = jQuery(elem);
  const top = $elem.offset().top;
  const height = $elem.height();
  const bottom = top + height;
  return (top >= viewportTop && top < viewportBottom) ||
    (bottom > viewportTop && bottom <= viewportBottom) ||
    (height > viewportHeight && top <= viewportTop && bottom >= viewportBottom);
}

function checkStickyAtcVisibility(fadeDuration = 10) {
  const $nonStickyButtons = $('.non-sticky-atc-button');
  const isAnyButtonVisible = Array.from({ length: 7 }, (_, i) => isOnScreen($nonStickyButtons.eq(i))).some(Boolean) || isOnScreen($('#footer'));
  const $stickyButton = $('.sticky-atc-button');
  if (isAnyButtonVisible) {
    $stickyButton.fadeOut(fadeDuration);
  } else {
    $stickyButton.fadeIn(fadeDuration);
  }
}

$(document).ready(function () {
  checkStickyAtcVisibility(100);
  $(window).on('scroll', () => checkStickyAtcVisibility(10));

  const announcementBarHeight = $('.announcement-bar').height();
  const deskHeaderHeight = $('.header').height();
  const deskTotalHeight = deskHeaderHeight + announcementBarHeight;
  const mbHeaderHeight = $('.mobile-header').height();
  const mbTotalHeight = mbHeaderHeight + announcementBarHeight;

  $('.scrollTo').click(function (e) {
    e.preventDefault();
    const jump = jQuery(this).attr('href');
    const scroll = $(window).width() > 767 ? -deskTotalHeight : -mbTotalHeight;
    const animateScroll = () => {
      const newPosition = jQuery(jump).offset();
      jQuery('html, body').stop().animate({ scrollTop: newPosition.top + scroll }, 800);
    };
    animateScroll();
    setTimeout(animateScroll, 800);
  });

  if ($('.jsClientLogoSlider').length > 0) {
    $('.jsClientLogoSlider').slick({
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 6,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      arrows: false,
      dots: false
    });
  }

  if ($('.jsLovedByCustomers').length > 0) {
    $('.jsLovedByCustomers').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      appendDots: $('.custom-dots'),
      prevArrow: '.custom-prev',
      nextArrow: '.custom-next',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1.4,
            slidesToScroll: 1,
            dots: false,
            infinite: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            dots: true
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true
          }
        }
      ]
    });
  }

  if ($('.jsSupportedByVets').length > 0) {
    $('.jsSupportedByVets').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      appendDots: $('.custom-dots-supported-vets'),
      prevArrow: '.custom-prev-supported-vets',
      nextArrow: '.custom-next-supported-vets',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            infinite: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true
          }
        }
      ]
    });
  }

  function applyMatchHeight() {
    const windowWidth = $(window).width();
    const shouldApply = windowWidth <= 991;
    const $immunityList = $('.sp-immunity-treats__box-list li');
    const $foodLists = $('.healthy-food-list li, .regular-food-list li');
    if (shouldApply) {
      $immunityList.matchHeight({ byRow: false });
      $foodLists.matchHeight({ byRow: false });
    } else {
      $immunityList.matchHeight('remove');
      $foodLists.matchHeight('remove');
    }
  }

  applyMatchHeight();
  $(window).resize(applyMatchHeight);

  const matchHeightSelectors = [
    { selector: '.sp-ingredients__box h6', byRow: true },
    { selector: '.sp-benefits-nutri-paw__box h6', byRow: true },
    { selector: '.sp-loved-by-customers__review-box > p', byRow: true }
  ];
  matchHeightSelectors.forEach(({ selector, byRow }) => {
    const $elements = $(selector);
    if ($elements.length > 0) {
      $elements.matchHeight({ byRow });
    }
  });

  function initAccordion(titleSelector, cardSelector, panelSelector, accordionSelector) {
    $(titleSelector).click(function (e) {
      e.preventDefault();
      const $title = $(this);
      const $card = $title.closest(cardSelector);
      const $panel = $card.find(panelSelector);
      const $accordion = $title.closest(accordionSelector);
      $accordion.find(panelSelector).not($panel).slideUp();
      if ($title.hasClass('active')) {
        $title.removeClass('active');
        $title.parents(cardSelector).removeClass('active');
      } else {
        $accordion.find(titleSelector + '.active').removeClass('active');
        $title.addClass('active');
        $accordion.find(cardSelector + '.active').removeClass('active');
        $title.parents(cardSelector).addClass('active');
      }
      $panel.stop(false, true).slideToggle();
    });
  }

  initAccordion('.cus-accordian-title', '.cus-accordian-card', '.cus-accordian-panel', '.cus-accordian');
  initAccordion('.sp-cus-accordian-title', '.sp-cus-accordian-card', '.sp-cus-accordian-panel', '.sp-cus-accordian');

  if ($('.jsProductBannerMain').length) {
    $('.jsProductBannerMain').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.jsProductBnnerNav',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: true
          }
        }
      ]
    });
  }

  if ($('.jsProductBnnerNav').length) {
    $('.jsProductBnnerNav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.jsProductBannerMain',
      dots: false,
      arrows: true,
      centerMode: false,
      focusOnSelect: true,
      prevArrow: '<button type="button" class="prev-arrow"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.96875" width="28" height="28" rx="14" fill="#18D371"/><path d="M16.6004 19.1686L12.4004 14.9686L16.6004 10.7686" stroke="white" stroke-width="1.86667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="next-arrow"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="28" height="28" rx="14" transform="matrix(-1 0 0 1 28.5 0.96875)" fill="#18D371"/><path d="M12.3996 19.1686L16.5996 14.9686L12.3996 10.7686" stroke="white" stroke-width="1.86667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            vertical: false,
            slidesToShow: 5,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  $(document).on('click', '.lp-add-to-cart', function () {
    const quantity = 1;
    const id = '36559416262817';
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { id, quantity },
      success: function () {
        location.href = '/checkout';
      }
    });
  });
});
